import http from './httpService';
import config from '../configs/config.js';

const url = config.apiEndPoint + '/users';

function generateURL(path) {
  return `${url}/${path}`;
}

// 1. Get user information
export async function getUsers() {
  let users = await http.get(url);
  return users;
}

export async function getUserbyID(id) {
  let user = await http.get(generateURL(id));
  return user;
}

export async function getMyData() {
  let user = await http.get(generateURL('me'));
  if (!localStorage.getItem('darkMode'))
    localStorage.setItem('darkMode', false);
  return user;
}

// 2. Create new user
export async function createUser(user) {
  const body = {
    email: user.email,
    is_active: user.is_active,
    is_superuser: user.is_superuser,
    first_name: user.first_name,
    last_name: user.last_name,
    password: user.password
  };
  let users = await http.post(url, body);
  return users;
}

// 3. Edit user permissions
export async function editUser(user, id) {
  const body = user;
  let users = await http.put(generateURL(id), body);
  return users;
}

export async function editMe(user) {
  const body = user;
  let users = await http.put(generateURL('me'), body);
  return users;
}

// 4. Delete user
export async function deleteUser(user) {
  let users = await http.delete(generateURL(user.user_uuid));
  return users;
}
